import { provideBrightnavAdminPlugin } from './brightnav-admin.plugin';

/** Providers for the BrightNav administration subapp (menu + lazy routes). */
export const BrightnavAdminModule = [...provideBrightnavAdminPlugin()];
